import { FC } from 'react'
import { DevTool } from 'src/features/development'
import { useDevelopmentHooks } from 'src/features/development/hooks'

const devToolStyle = {
  // backgroundImage: `url(${'/runningSole3.jpg'})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'left -58px top 32px',
  backgroundSize: '115%',
  maxWidth: '100%'
}

type Props = {
  sideSurfaceId: string
  maxWidth?: '100%' | '50%' | '30%'
}

export const SideSurface: FC<Props> = ({ sideSurfaceId, maxWidth = '100%' }) => {
  const { devFlg, devTools, handleCoordinate } = useDevelopmentHooks()
  return (
    <>
      {devFlg === 'true' ? (
        <div>
          <canvas width={880} height={680} id={sideSurfaceId} style={{ ...devToolStyle }} onClick={(e) => handleCoordinate(e)} />
          <DevTool devTools={devTools} />
        </div>
      ) : (
        <canvas id={sideSurfaceId} width={880} height={680} style={{ maxWidth }} />
      )}
    </>
  )
}
